<template>
	<AlertCardWrapper :title="title" :alert="alert">
		<template #subtitle>
			<SubTitle :text="subtitle" />

			<SubTitle v-if="handledBy" :text="handledBy" />
		</template>
	</AlertCardWrapper>
</template>
<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMemberByUserId } from '@/store/modules/account/getters';

export default {
	name: 'FeatureNotification',
	mixins: [AlertTypeBaseMixin],
	computed: {
		...mapGettersShorthand({ teamMemberByUserId }),
		title() {
			return this.alert.metadata.title || 'Go to url';
		},
		subtitle() {
			return this.alert.metadata.subtitle;
		},
		handledBy() {
			const resumerId = this.alert.metadata.resume_user_id;
			if (resumerId) {
				const username = this.teamMemberByUserId(resumerId)?.name;
				if (username) {
					return `handled by ${username}`;
				}
			}
			return null;
		},
	},
};
</script>
